import { format } from 'date-fns';
import { createSelector } from 'reselect';

// Action Types

const SELECT_SETTINGS_DATARESEND_DATE_RANGE =
  'SELECT_SETTINGS_DATARESEND_DATE_RANGE' as const;
const SELECT_SETTINGS_DATARESEND_HALL_CODE =
  'SELECT_SETTINGS_DATARESEND_HALL_CODE' as const;
const SELECT_SETTINGS_DATARESEND_DATE_UNIT =
  'SELECT_SETTINGS_DATARESEND_DATE_UNIT' as const;

export const SettingsDataResendActionTypes = {
  SELECT_SETTINGS_DATARESEND_DATE_RANGE,
  SELECT_SETTINGS_DATARESEND_HALL_CODE,
  SELECT_SETTINGS_DATARESEND_DATE_UNIT,
};

// Action Creators

function selectSettingsDataResendDateRangeAction(resendDate: string[]) {
  return {
    type: SELECT_SETTINGS_DATARESEND_DATE_RANGE,
    payload: {
      resendDate,
    },
  };
}

function selectSettingsDataResendHallCodeAction(hallCode: string) {
  return {
    type: SELECT_SETTINGS_DATARESEND_HALL_CODE,
    payload: {
      hallCode,
    },
  };
}

function selectSettingsDataResendDateUnitAction(
  dateUnit: '範囲選択' | '自由選択'
) {
  return {
    type: SELECT_SETTINGS_DATARESEND_DATE_UNIT,
    payload: { dateUnit },
  };
}

export const SettingsDataResendActionCreators = {
  selectSettingsDataResendDateRangeAction,
  selectSettingsDataResendHallCodeAction,
  selectSettingsDataResendDateUnitAction,
};

// Actions
type SettingsDataResendAction =
  | ReturnType<typeof selectSettingsDataResendDateRangeAction>
  | ReturnType<typeof selectSettingsDataResendHallCodeAction>
  | ReturnType<typeof selectSettingsDataResendDateUnitAction>;

// State

type SettingsDataResendState = {
  hallCode: string;
  resendDate: string[]; // 再送信日は複数日選択可能
  dateUnit: '範囲選択' | '自由選択';
};

const initialState: SettingsDataResendState = {
  resendDate: [format(new Date(), 'yyyy-MM-dd')],
  hallCode: 'none',
  dateUnit: '範囲選択',
};

// Selector
function settingsDataResendSelector(rootState: {
  settingsDataResend: SettingsDataResendState;
}) {
  return rootState.settingsDataResend;
}

/**
 * 選択した再送信日の取得
 */
export const settingsDataResendDateRangeSelector = createSelector(
  settingsDataResendSelector,
  ({ resendDate, dateUnit }) => ({
    resendDate,
    dateUnit,
  })
);

/**
 * 選択した店舗の取得
 */
export const settingsDataResendHallCodeSelector = createSelector(
  settingsDataResendSelector,
  ({ hallCode }) => hallCode
);

// Reducer

export function settingsDataResendReducer(
  state = initialState,
  action: SettingsDataResendAction
): SettingsDataResendState {
  switch (action.type) {
    case SELECT_SETTINGS_DATARESEND_DATE_RANGE:
    case SELECT_SETTINGS_DATARESEND_HALL_CODE:
    case SELECT_SETTINGS_DATARESEND_DATE_UNIT: {
      return {
        ...state,
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
